// import { GlobalStyles } from "@/components/shared/utilities/GlobalStyles/GlobalStyles";
import { Box, BoxProps } from "@chakra-ui/react";
import { FC } from "react";

import { motion } from "framer-motion";

export const AuthLayout: FC<BoxProps> = ({ children }) => {
  return (
    <Box as={motion.div} minH="full" animation="fa">
      {children}
    </Box>
  );
};
